<template>
    <div class="container-fluid">
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 px-3 px-md-0">
            <div>
                <h3 class="fw-bold mb-1">Samochody</h3>
                <p class="text-muted small mb-0">Zarządzanie ofertami pojazdów i ogłoszeniami w systemie</p>
            </div>
            <button
                class="btn btn-primary-dark d-flex align-items-center justify-content-center gap-2 w-100 btn-responsive-auto"
                @click="openAddModal">
                <i class="bi bi-plus-lg"></i>
                <span>Dodaj ogłoszenie</span>
            </button>
        </div>

        <div class="card border-0 shadow-sm">
            <div class="card-body">
                <div class="row mb-3 g-2">
                    <div class="col-12 col-md-3">
                        <SearchableSelectMakes v-model="selectedMakeId" placeholder="Wybierz markę"
                            @change="handleMakeChange" />
                    </div>
                    <div class="col-12 col-md-3">
                        <SearchableSelectModels v-model="selectedModelId" :make-id="selectedMakeId"
                            placeholder="Wybierz model" @change="handleModelChange" />
                    </div>
                    <div class="col-12 col-md-3">
                        <select class="form-select" v-model="filterActive" @change="loadData">
                            <option value="">Wszystkie statusy</option>
                            <option value="yes">Aktywne</option>
                            <option value="no">Nieaktywne</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="searchValue" @input="handleSearch" type="text" class="form-control"
                            placeholder="Szukaj (VIN)..." />
                    </div>
                </div>
                <div class="table-responsive w-100">
                    <Vue3EasyDataTable v-model:server-options="serverOptions" :headers="headers" :items="items"
                        :loading="loading" :server-items-length="serverItemsLength" buttons-pagination
                        class="table-font-13" table-class-name="table table-hover align-middle custom-easy-table"
                        :rows-items="[10, 25, 50, 100]" empty-message="Brak pojazdów do wyświetlenia"
                        rows-per-page-message="Wierszy na stronę:">

                        <template #item-image="item">
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 60px; height: 40px;">
                                <img v-if="item.image"
                                    :src="`https://integrator.wrealizacji.pl/photos/${item.ID}/thumb/${item.image}`"
                                    :alt="`${item.make} ${item.model}`"
                                    class="rounded object-fit-cover w-100 h-100 border cursor-pointer"
                                    @click="openImageModal(`https://integrator.wrealizacji.pl/photos/${item.ID}/full/${item.image}`)"
                                    @error="(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }" />

                                <div :class="['bg-light text-muted rounded align-items-center justify-content-center w-100 h-100 border', item.image ? 'd-none' : 'd-flex']"
                                    title="Brak zdjęcia">
                                    <i class="bi bi-car-front text-secondary fs-5"></i>
                                </div>
                            </div>
                        </template>
                        <template #loading>
                            <div class="py-4 text-center">Pobieranie danych, proszę czekać...</div>
                        </template>

                        <template #item-active="item">
                            <span v-if="item.active === 'yes'"
                                class="badge bg-success-subtle text-success border border-success-subtle">Aktywny</span>
                            <span v-else class="badge bg-light text-muted border">Nieaktywny</span>
                        </template>

                        <template #item-actions="item">
                            <div class="d-flex justify-content-end gap-1">
                                <button class="btn btn-sm btn-outline-danger" title="Generuj cenówkę PDF"
                                    @click="openPdfModal(item)">
                                    <i class="bi bi-file-earmark-pdf"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-success" title="Sprzedaj pojazd"
                                    @click="openSellModal(item)">
                                    <i class="bi bi-cart-check"></i>
                                </button>

                                <button class="btn btn-sm btn-primary-light" title="Edytuj"
                                    @click="openEditModal(item.ID)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger" title="Usuń" @click="deleteItem(item.ID)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </template>
                    </Vue3EasyDataTable>
                </div>
            </div>
        </div>

        <!-- Modal Formularza Pojazdu -->
        <div ref="modalRef" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content overflow-hidden">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold">{{ formTitle }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <form ref="formRef" @submit.prevent="handleSubmit" class="d-flex flex-column"
                        style="max-height: 85vh;">
                        <div class="modal-body custom-scroll-body">
                            <input type="hidden" name="id" :value="formData.ID" />

                            <!-- 1. MARKA, MODEL, GENERACJA, DEALER & STATUS -->
                            <div class="row g-3 mb-4">
                                <div class="col-12">
                                    <h6 class="fw-bold border-bottom pb-2">1. Podstawowe dane i przynależność</h6>
                                </div>

                                <div class="col-12 col-md-3">
                                    <label class="form-label">Marka *</label>
                                    <SearchableSelectMakes v-model="formData.makeID" placeholder="Wybierz markę"
                                        @change="handleFormMakeChange" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Model *</label>
                                    <SearchableSelectModels v-model="formData.modelID" :make-id="formData.makeID"
                                        placeholder="Wybierz model" @change="handleFormModelChange" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Generacja</label>
                                    <select class="form-select" v-model="formData.generationID"
                                        :disabled="!formData.modelID || loadingGenerations">
                                        <option :value="null">
                                            {{ loadingGenerations ? 'Ładowanie...' : '-- Wybierz generację --' }}
                                        </option>
                                        <option v-for="gen in generationsList" :key="gen.ID || gen.id"
                                            :value="gen.ID || gen.id">{{ gen.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Status oferty</label>
                                    <select class="form-select" v-model="formData.statusID">
                                        <option :value="null">-- Wybierz status --</option>
                                        <option v-for="s in dicts.statuses" :key="s.ID || s.id" :value="s.ID || s.id">{{
                                            s.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- 2. SPECYFIKACJA TECHNICZNA -->
                            <div class="row g-3 mb-4">
                                <div class="col-12">
                                    <h6 class="fw-bold border-bottom pb-2">2. Specyfikacja techniczna</h6>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Rodzaj paliwa *</label>
                                    <select class="form-select" v-model="formData.fuelTypeID" required>
                                        <option :value="null">-- Wybierz paliwo --</option>
                                        <option v-for="f in dicts.fuelTypes" :key="f.ID || f.id" :value="f.ID || f.id">
                                            {{ f.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Skrzynia biegów *</label>
                                    <select class="form-select" v-model="formData.gearboxID" required>
                                        <option :value="null">-- Wybierz skrzynię --</option>
                                        <option v-for="g in dicts.gearboxes" :key="g.ID || g.id" :value="g.ID || g.id">
                                            {{ g.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Typ nadwozia *</label>
                                    <select class="form-select" v-model="formData.bodyTypeID" required>
                                        <option :value="null">-- Wybierz nadwozie --</option>
                                        <option v-for="b in dicts.bodyTypes" :key="b.ID || b.id" :value="b.ID || b.id">
                                            {{ b.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Napęd *</label>
                                    <select class="form-select" v-model="formData.driveTypeID" required>
                                        <option :value="null">-- Wybierz napęd --</option>
                                        <option v-for="dr in dicts.driveTypes" :key="dr.ID || dr.id"
                                            :value="dr.ID || dr.id">{{
                                                dr.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Kolor *</label>
                                    <select class="form-select" v-model="formData.colourID" required>
                                        <option :value="null">-- Wybierz kolor --</option>
                                        <option v-for="c in dicts.colours" :key="c.ID || c.id" :value="c.ID || c.id">{{
                                            c.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Pojemność silnika (cm³)</label>
                                    <input type="number" class="form-control" v-model="formData.engineCCM"
                                        placeholder="" />
                                </div>

                                <div class="col-12 col-md-3">
                                    <label class="form-label">Moc (KM)</label>
                                    <input type="number" class="form-control" v-model="formData.powerKM"
                                        @input="onPowerKMChange" placeholder="" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Moc (kW)</label>
                                    <input type="number" class="form-control" v-model="formData.powerKW"
                                        @input="onPowerKWChange" placeholder="" />
                                </div>
                            </div>

                            <!-- 3. IDENTYFIKACJA I STAN -->
                            <div class="row g-3 mb-4">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2">
                                    <h6 class="fw-bold mb-0">3. Identyfikacja i stan</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Numer VIN</label>
                                    <input type="text" class="form-control text-uppercase" v-model="formData.VIN"
                                        maxlength="17" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Numer rejestracyjny</label>
                                    <input type="text" class="form-control text-uppercase"
                                        v-model="formData.registerNumber" placeholder="" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Kraj pochodzenia</label>
                                    <select class="form-select" v-model="formData.countryID">
                                        <option :value="null">-- Wybierz kraj --</option>
                                        <option v-for="country in dicts.countries" :key="country.ID || country.id"
                                            :value="country.ID || country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Przebieg (km) *</label>
                                    <input type="number" class="form-control" v-model="formData.mileage" required />
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Rok produkcji *</label>
                                    <input type="number" class="form-control" v-model="formData.productionYear"
                                        required />
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Data pierwszej rejestracji</label>
                                    <input type="date" class="form-control" v-model="formData.firstRegistrationDate" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Liczba drzwi</label>
                                    <input type="number" class="form-control" v-model="formData.doorCount" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Liczba miejsc</label>
                                    <input type="number" class="form-control" v-model="formData.seatsCount" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Ilość kluczyków</label>
                                    <input type="text" class="form-control" v-model="formData.keyCount"
                                        placeholder="" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Nr kluczyka</label>
                                    <input type="text" class="form-control" v-model="formData.keyNumber"
                                        placeholder="" />
                                </div>

                                <div class="col-12 col-md-3">
                                    <label class="form-label fw-semibold small mb-1">Typ pojazdu</label>
                                    <select class="form-select form-select-sm" v-model="formData.type">
                                        <option value="">-- wybierz --</option>
                                        <option value="osobowy">Osobowy</option>
                                        <option value="dostawczy">Dostawczy</option>
                                        <option value="ciezarowy">Ciężarowy</option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Bezwypadkowy</label>
                                    <select class="form-select" v-model="formData.accidentFree">
                                        <option value="yes">Tak</option>
                                        <option value="no">Nie</option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Uszkodzony</label>
                                    <select class="form-select" v-model="formData.damaged">
                                        <option value="no">Nie</option>
                                        <option value="yes">Tak</option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label class="form-label">Sprowadzony z zagranicy</label>
                                    <select class="form-select" v-model="formData.imported">
                                        <option value="no">Nie</option>
                                        <option value="yes">Tak</option>
                                    </select>
                                </div>
                            </div>

                            <!-- 4. FINANSE, DOKUMENTY I GWARANCJA -->
                            <div class="row g-3 mb-4">
                                <div class="col-12">
                                    <h6 class="fw-bold border-bottom pb-2">4. Finanse i opcje oferty</h6>
                                </div>
                                <div class="col-12 col-md-4">
                                    <label class="form-label">Cena (PLN) *</label>
                                    <input type="number" step="0.01" class="form-control" v-model="formData.price"
                                        required />
                                </div>
                                <div class="col-12 col-md-8 d-flex align-items-center flex-wrap gap-3 pt-md-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="priceNettoCheck"
                                            v-model="formData.priceNetto">
                                        <label class="form-check-label fw-semibold" for="priceNettoCheck">Cena
                                            netto</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="negotiableCheck"
                                            v-model="formData.negotiable">
                                        <label class="form-check-label fw-semibold" for="negotiableCheck">Do
                                            negocjacji</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="vatMarginCheck"
                                            v-model="formData.vatMargin">
                                        <label class="form-check-label fw-semibold" for="vatMarginCheck">VAT
                                            marża</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="vatInvoiceCheck"
                                            v-model="formData.vatInvoice">
                                        <label class="form-check-label fw-semibold" for="vatInvoiceCheck">Faktura
                                            VAT</label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <label class="form-label d-block fw-semibold text-muted small uppercase mb-2">Usługi
                                        i
                                        Gwarancje</label>
                                    <div class="d-flex flex-wrap gap-3 align-items-center bg-light p-3 rounded border">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="deliveryPossibleCheck"
                                                v-model="formData.deliveryPossible">
                                            <label class="form-check-label" for="deliveryPossibleCheck">Możliwość
                                                dowozu</label>
                                        </div>
                                        <div class="vr mx-2 d-none d-md-block"></div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="warranty3mCheck"
                                                v-model="formData.warranty3m">
                                            <label class="form-check-label" for="warranty3mCheck">Gwarancja 3
                                                miesiące</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="warranty12mCheck"
                                                v-model="formData.warranty12m">
                                            <label class="form-check-label" for="warranty12mCheck">Gwarancja 12
                                                miesięcy</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="warranty24mCheck"
                                                v-model="formData.warranty24m">
                                            <label class="form-check-label" for="warranty24mCheck">Gwarancja 24
                                                miesiące</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="ocCheck"
                                                v-model="formData.ocInsurance">
                                            <label class="form-check-label" for="ocCheck">Ubezpieczenie OC</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 pt-2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="activeCheck"
                                            v-model="formData.active">
                                        <label class="form-check-label fw-bold" for="activeCheck">Ogłoszenie
                                            aktywne</label>
                                    </div>
                                </div>
                            </div>

                            <!-- 5. OPIS OFERTY -->
                            <div class="row g-3 mb-4">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2">
                                    <h6 class="fw-bold mb-0">5. Treść ogłoszenia</h6>

                                    <div v-if="dicts.descriptionTemplates.length > 0"
                                        class="d-flex align-items-center gap-2">
                                        <select class="form-select form-select-sm"
                                            @change="handleTemplateSelect($event)">
                                            <option value="" disabled selected>-- Wybierz szablon opisu --</option>
                                            <option v-for="tpl in dicts.descriptionTemplates" :key="tpl.ID || tpl.id"
                                                :value="tpl.ID || tpl.id">
                                                {{ tpl.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label class="form-label">Opis oferty</label>
                                    <textarea ref="textareaRef" class="form-control" rows="6"
                                        v-model="formData.offerDesc"
                                        placeholder="Wprowadź pełny opis pojazdu dla portali lub wstaw tagi szablonu..."></textarea>
                                </div>
                            </div>

                            <!-- 6. WYPOSAŻENIE -->
                            <div class="row g-3 mb-4">
                                <div class="col-12">
                                    <h6 class="fw-bold border-bottom pb-2">6. Wyposażenie</h6>
                                </div>
                                <div class="col-12" v-if="loadingEquipment">
                                    <div class="text-muted small">Pobieranie listy wyposażenia...</div>
                                </div>
                                <div class="col-12" v-else-if="equipmentList.length === 0">
                                    <div class="text-muted small">Brak zdefiniowanego wyposażenia.</div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-3" v-for="eq in equipmentList" :key="eq.ID || eq.id">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'eq_' + (eq.ID || eq.id)"
                                            :value="eq.ID || eq.id" v-model="selectedEquipment" />
                                        <label class="form-check-label text-truncate w-100"
                                            :for="'eq_' + (eq.ID || eq.id)" :title="eq.name">
                                            {{ eq.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- 7. GALERIA ZDJĘĆ -->
                            <div class="row g-3 mb-2">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2">
                                    <h6 class="fw-bold mb-0">7. Galeria zdjęć</h6>
                                    <span class="badge bg-light text-dark border">
                                        {{ photosList.length }} / {{ maxPhotosAllowed }} zdjęć
                                    </span>
                                </div>
                                <div class="col-12" v-if="photosList.length > 0">
                                    <div class="row g-2 mt-2">
                                        <div v-for="(photo, index) in photosList" :key="index"
                                            class="col-6 col-sm-4 col-md-3">
                                            <div class="card h-100 position-relative border"
                                                :class="{ 'border-primary border-2': photo.main }">
                                                <img :src="photo.preview" class="card-img-top object-fit-cover"
                                                    style="height: 120px;" />
                                                <div class="card-body p-2 text-center">
                                                    <div class="d-flex justify-content-center gap-1 mb-2">
                                                        <button type="button" class="btn btn-xs btn-outline-secondary"
                                                            :disabled="index === 0" @click="movePhoto(index, -1)">
                                                            <i class="bi bi-arrow-left"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-xs btn-outline-secondary"
                                                            :disabled="index === photosList.length - 1"
                                                            @click="movePhoto(index, 1)">
                                                            <i class="bi bi-arrow-right"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-xs btn-outline-danger"
                                                            @click="removePhoto(index)">
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                    <button type="button" class="btn btn-sm w-100"
                                                        :class="photo.main ? 'btn-primary' : 'btn-outline-primary'"
                                                        @click="setMainPhoto(index)">
                                                        {{ photo.main ? 'Główne' : 'Ustaw główne' }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="drop-zone border-2 border-dashed rounded p-4 text-center cursor-pointer"
                                        :class="{
                                            'drop-zone-active bg-light-primary border-primary': isDragging && photosList.length < maxPhotosAllowed,
                                            'bg-light text-muted opacity-75 cursor-not-allowed': photosList.length >= maxPhotosAllowed
                                        }" @dragover.prevent="isDragging = photosList.length < maxPhotosAllowed"
                                        @dragleave.prevent="isDragging = false" @drop.prevent="handleDrop"
                                        @click="triggerFileInput">

                                        <i class="bi fs-2"
                                            :class="photosList.length >= maxPhotosAllowed ? 'bi-image text-secondary' : 'bi-cloud-arrow-up text-primary'"></i>

                                        <p class="mb-0 mt-2 fw-medium" v-if="photosList.length < maxPhotosAllowed">
                                            Przeciągnij i upuść zdjęcia tutaj lub <span
                                                class="text-primary text-decoration-underline">wybierz z pliku</span>
                                        </p>
                                        <p class="mb-0 mt-2 fw-medium text-warning" v-else>
                                            Osiągnięto limit {{ maxPhotosAllowed }} zdjęć dla wybranego pakietu
                                        </p>

                                        <span class="text-muted extra-small">Obsługiwane formaty: JPG, PNG, WEBP</span>
                                        <input type="file" ref="fileInput" class="d-none" multiple accept="image/*"
                                            :disabled="photosList.length >= maxPhotosAllowed"
                                            @change="handlePhotosSelect" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer bg-light border-top">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Anuluj</button>
                            <button type="submit" class="btn btn-primary">Zapisz ogłoszenie</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Modal Wyboru Szablonu Cenówki -->
        <div ref="pdfModalRef" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold">
                            <i class="bi bi-file-earmark-pdf text-danger me-2"></i>Wybierz szablon cenówki
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted small">Wybierz wzór cenówki, który ma zostać wygenerowany dla pojazdu
                            <strong>{{
                                selectedCarForPdf?.make }} {{ selectedCarForPdf?.model }}</strong>.
                        </p>
                        <div class="list-group">
                            <button v-for="tpl in templatesList" :key="tpl.id" type="button"
                                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center p-3"
                                :class="{ 'active': selectedTemplateId === tpl.id }"
                                @click="selectedTemplateId = tpl.id">
                                <div>
                                    <div class="fw-bold">{{ tpl.name }}</div>
                                    <small
                                        :class="selectedTemplateId === tpl.id ? 'text-white-50' : 'text-muted'">Identyfikator:
                                        {{ tpl.id }}</small>
                                </div>
                                <i class="bi"
                                    :class="selectedTemplateId === tpl.id ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Anuluj</button>
                        <button type="button" class="btn btn-danger d-flex align-items-center gap-2"
                            :disabled="!selectedTemplateId || generatingPdf" @click="generatePdf">
                            <i class="bi bi-file-earmark-pdf"></i>
                            <span>{{ generatingPdf ? 'Generowanie...' : 'Otwórz podgląd PDF' }}</span>
                        </button>
                        <button type="button" class="btn btn-outline-primary" @click="openHtmlPreview">
                            <i class="bi bi-code-slash"></i> Podgląd HTML
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ukryty kontener dla szablonów na potrzeby html2pdf -->
        <div style="position: absolute; left: -9999px; top: -9999px;">
            <div ref="pdfRenderArea">
                <component :is="currentTemplateComponent" v-if="pdfCarDetails && currentTemplateComponent"
                    :car="pdfCarDetails" />
            </div>
        </div>

        <div v-if="activePreviewImage" class="modal fade show d-block" tabindex="-1"
            style="background-color: rgba(0, 0, 0, 0.85); z-index: 1055;" @click.self="closeImageModal">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content bg-transparent border-0 text-end">
                    <button type="button" class="btn-close btn-close-white mb-2 ms-auto"
                        @click="closeImageModal"></button>
                    <div class="text-center">
                        <img :src="activePreviewImage" class="img-fluid rounded shadow-lg"
                            style="max-height: 85vh; object-fit: contain;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="glownyloader">
        <AppLoader :show="saving || generatingPdf" :text="savingTXT" />
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, nextTick, computed } from 'vue'
import apiClient from '@/api'
import Modal from 'bootstrap/js/dist/modal'
import html2pdf from 'html2pdf.js'
import AppLoader from '@/components/AppLoader.vue'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import { webAlert, showConfirm } from '@/utils/dialog'
import { useRouter } from 'vue-router'
import SearchableSelectMakes from '@/components/SearchableSelectMakes.vue'
import SearchableSelectModels from '@/components/SearchableSelectModels.vue'

// AUTOMATYCZNE WYKRYWANIE SZABLONÓW Z KATALOGU components/templates/
const templatesList = ref([])
const templatesMap = {}
const templatesMetaMap = {} // Dedykowana mapa na same metadane

const templateFiles = require.context('../components/templates', false, /\.vue$/)

const openHtmlPreview = async () => {
    if (!selectedCarForPdf.value || !selectedTemplateId.value) return

    savingTXT.value = 'Pobieranie danych pojazdu...'
    generatingPdf.value = true

    try {
        const response = await apiClient.post(
            { action: 'get-car-details', ID: selectedCarForPdf.value.ID }
        )

        pdfCarDetails.value = response.data?.data?.[0] || response.data?.data || response.data
        await nextTick()

        // Pobieramy wyrenderowany kod HTML z ukrytej sekcji pdfRenderArea
        const htmlContent = pdfRenderArea.value.innerHTML
        const selectedMeta = templatesMetaMap[selectedTemplateId.value]
        const isLandscape = selectedMeta?.orientation === 'landscape'

        // Otwieramy nowe okno i wstrzykujemy tam HTML ze stylami strony A4
        const win = window.open('', '_blank')
        win.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Podgląd HTML - Cenówka</title>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
                <style>
                    body {
                        background-color: #f0f0f0;
                        display: flex;
                        justify-content: center;
                        padding: 20px;
                    }
                    .a4-page {
                        background: white;
                        box-shadow: 0 0 10px rgba(0,0,0,0.15);
                        width: ${isLandscape ? '297mm' : '210mm'};
                        height: ${isLandscape ? '210mm' : '297mm'};
                        box-sizing: border-box;
                        overflow: hidden;
                    }
                    @media print {
                        body { background: none; padding: 0; }
                        .a4-page { box-shadow: none; }
                    }
                </style>
            </head>
            <body>
                <div class="a4-page">
                    ${htmlContent}
                </div>
            </body>
            </html>
        `)
        win.document.close()
    } catch (err) {
        console.error(err)
    } finally {
        generatingPdf.value = false
    }
}

templateFiles.keys().forEach((filePath) => {
    const fileModule = templateFiles(filePath)
    const component = fileModule.default || fileModule

    // Pobieranie templateMeta - sprawdza bezpośrednio export pliku oraz właściwości komponentu
    const meta = fileModule.templateMeta || component.templateMeta || component.__vccOpts?.templateMeta || {}

    const fileName = filePath.replace(/^.+\//, '').replace(/\.\w+$/, '')
    const id = meta.id || fileName
    const name = meta.name || fileName
    const orientation = meta.orientation || 'portrait'

    templatesMap[id] = component
    templatesMetaMap[id] = { id, name, orientation, ...meta }

    templatesList.value.push({ id, name, orientation })
})

const selectedTemplateId = ref(templatesList.value[0]?.id || null)
const pdfModalRef = ref(null)
let pdfModalInstance = null
const selectedCarForPdf = ref(null)
const pdfCarDetails = ref(null)
const pdfRenderArea = ref(null)
const generatingPdf = ref(false)

const currentTemplateComponent = computed(() => {
    return selectedTemplateId.value ? templatesMap[selectedTemplateId.value] : null
})

const openPdfModal = (carItem) => {
    selectedCarForPdf.value = carItem
    if (templatesList.value.length > 0 && !selectedTemplateId.value) {
        selectedTemplateId.value = templatesList.value[0].id
    }
    pdfModalInstance.show()
}

const generatePdf = async () => {
    if (!selectedCarForPdf.value || !selectedTemplateId.value) return

    generatingPdf.value = true
    savingTXT.value = 'Pobieranie danych pojazdu...'

    try {
        const response = await apiClient.post(
            { action: 'get-car-details', ID: selectedCarForPdf.value.ID }
        )

        const item = response.data?.data?.[0] || response.data?.data || response.data
        pdfCarDetails.value = item

        savingTXT.value = 'Generowanie podglądu PDF...'
        await nextTick()

        const element = pdfRenderArea.value

        // 1. Odczytujemy orientację z naszej dedykowanej mapy metadanych
        const selectedMeta = templatesMetaMap[selectedTemplateId.value]
        const currentOrientation = selectedMeta?.orientation || 'portrait'

        console.log('Wybrany szablon:', selectedTemplateId.value)
        console.log('Wykryta orientacja:', currentOrientation)

        // 2. Konfiguracja opt z dynamiczną orientacją
        const opt = {
            margin: 0,
            filename: `Cenowka_${item.make || ''}_${item.model || ''}_${item.ID}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: currentOrientation // 'landscape' lub 'portrait'
            }
        }

        // 3. Wygenerowanie PDF jako Blob i otwarcie w nowej karcie
        const pdfWorker = html2pdf().set(opt).from(element)
        const pdfBlob = await pdfWorker.output('blob')

        const blobUrl = URL.createObjectURL(pdfBlob)
        window.open(blobUrl, '_blank')

        pdfModalInstance.hide()
    } catch (err) {
        console.error(err)
        generatingPdf.value = false
        webAlert('Błąd podczas generowania podglądu PDF.')
    } finally {
        generatingPdf.value = false
    }
}

const router = useRouter()
const maxPhotosAllowed = ref(5)

const textareaRef = ref(null)

const headers = [
    { text: 'ID', value: 'ID', sortable: true, width: 60 },
    { text: 'Miniatura', value: 'image', sortable: false },
    { text: 'Marka', value: 'make', sortable: true },
    { text: 'Model', value: 'model', sortable: true },
    { text: 'Dealer', value: 'dealerName', sortable: true },
    { text: 'Rok', value: 'productionYear', sortable: true },
    { text: 'Przebieg', value: 'mileage', sortable: true },
    { text: 'Cena (PLN)', value: 'price', sortable: true },
    { text: 'Status', value: 'active', sortable: true },
    { text: '', value: 'actions', width: 130 }
]

const items = ref([])
const loading = ref(false)
const saving = ref(false)
const savingTXT = ref('')
const searchValue = ref('')
const filterActive = ref('')

const activePreviewImage = ref(null)

const openImageModal = (url) => {
    activePreviewImage.value = url
}

const closeImageModal = () => {
    activePreviewImage.value = null
}

const serverItemsLength = ref(0)
const serverOptions = ref({
    page: 1,
    rowsPerPage: 10,
    sortBy: 'ID',
    sortType: 'desc'
})

const selectedMakeId = ref(null)
const selectedModelId = ref(null)

const handleMakeChange = (make) => {
    selectedMakeId.value = make?.ID ?? make?.makeID ?? make?.id ?? null
    selectedModelId.value = null
    loadData()
}

const handleModelChange = (model) => {
    selectedModelId.value = model?.ID ?? model?.modelID ?? model?.id ?? null
    loadData()
}


const openSellModal = (item) => {
    router.push({
        path: '/admin/invoices',
        query: {
            vehicleId: item.ID,
            make: item.make || '',
            model: item.model || ''
        }
    })
}

const loadData = async () => {
    loading.value = true
    try {
        const response = await apiClient.post(
            {
                method: 'post',
                action: 'get-cars',
                page: serverOptions.value.page,
                limit: serverOptions.value.rowsPerPage,
                sortBy: serverOptions.value.sortBy,
                sortType: serverOptions.value.sortType,
                search: searchValue.value,
                makeID: selectedMakeId.value,
                modelID: selectedModelId.value,
                active: filterActive.value
            }
        )

        localStorage.setItem('max_photos', response.data.ctd.imagesToAdvert)
        maxPhotosAllowed.value = response.data.ctd.imagesToAdvert
        
        items.value = Array.isArray(response.data?.data) ? response.data.data : []
        serverItemsLength.value = response.data?.total || 0
    } catch {
        webAlert('Błąd podczas ładowania danych samochodów.')
    } finally {
        loading.value = false
    }
}

watch(serverOptions, () => { loadData() }, { deep: true })

let searchTimeout = null
const handleSearch = () => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
        serverOptions.value.page = 1
        loadData()
    }, 400)
}

const dicts = reactive({
    dealers: [],
    makes: [],
    models: [],
    fuelTypes: [],
    gearboxes: [],
    bodyTypes: [],
    colours: [],
    driveTypes: [],
    countries: [],
    statuses: [],
    descriptionTemplates: []
})

const fetchDict = async (action, extraData = {}) => {
    try {
        const res = await apiClient.post({ action, ...extraData })
        return Array.isArray(res.data?.data) ? res.data.data : []
    } catch { return [] }
}

const equipmentList = ref([])
const selectedEquipment = ref([])
const loadingEquipment = ref(false)

const generationsList = ref([])
const loadingGenerations = ref(false)

const modalRef = ref(null)
const formRef = ref(null)
const fileInput = ref(null)
const isDragging = ref(false)
let modalInstance = null

const formTitle = ref('Dodaj samochód')
const photosList = ref([])

const formData = ref({
    ID: '',
    dealerID: null,
    makeID: null,
    modelID: null,
    generationID: null,
    statusID: null,
    fuelTypeID: null,
    gearboxID: null,
    bodyTypeID: null,
    colourID: null,
    driveTypeID: null,
    countryID: null,
    VIN: '',
    registerNumber: '',
    price: '',
    priceNetto: false,
    negotiable: false,
    vatMargin: false,
    vatInvoice: false,
    keyCount: '',
    keyNumber: '',
    deliveryPossible: false,
    warranty3m: false,
    warranty12m: false,
    warranty24m: false,
    ocInsurance: false,
    type: null,
    firstRegistrationDate: '',
    engineCCM: '',
    powerKM: '',
    powerKW: '',
    mileage: '',
    productionYear: new Date().getFullYear(),
    doorCount: 5,
    seatsCount: 5,
    damaged: 'no',
    imported: 'no',
    accidentFree: 'no',
    offerDesc: '',
    active: false
})

const loadDictionaries = async () => {
    dicts.dealers = await fetchDict('get-dealers')
    dicts.makes = await fetchDict('get-makes')
    dicts.fuelTypes = await fetchDict('get-fueltypes')
    dicts.gearboxes = await fetchDict('get-gearboxes')
    dicts.bodyTypes = await fetchDict('get-bodytypes')
    dicts.colours = await fetchDict('get-colours')
    dicts.driveTypes = await fetchDict('get-drivetypes')
    dicts.countries = await fetchDict('get-countries')
    dicts.statuses = await fetchDict('get-statuses')
    dicts.descriptionTemplates = await fetchDict('get-description-generators', { limit: 100 })
}

const getNameFromDict = (list, id) => {
    if (!id || !Array.isArray(list)) return ''
    const found = list.find(item => String(item.ID ?? item.id ?? item.makeID ?? item.modelID) === String(id))
    return found ? (found.name || found.make_name || found.model_name || found.make || found.model || found.label || '') : ''
}

const getMakeName = (makeId) => getNameFromDict(dicts.makes, makeId)
const getModelName = (modelId) => getNameFromDict(dicts.models, modelId)

const handleFormMakeChange = async (make) => {
    formData.value.makeID = make?.ID ?? make?.makeID ?? make?.id ?? null
    formData.value.modelID = null
    formData.value.generationID = null
    generationsList.value = []

    if (formData.value.makeID) {
        dicts.models = await fetchDict('get-models', { makeID: formData.value.makeID })
    } else {
        dicts.models = []
    }
}

const handleFormModelChange = async (model) => {
    formData.value.modelID = model?.ID ?? model?.modelID ?? model?.id ?? null
    formData.value.generationID = null
    loadGenerations(formData.value.modelID)
}

const handleTemplateSelect = (event) => {
    const selectedId = event.target.value
    if (!selectedId) return

    const selectedTpl = dicts.descriptionTemplates.find(t => String(t.ID || t.id) === String(selectedId))

    if (selectedTpl) {
        let content = selectedTpl.template || selectedTpl.description || selectedTpl.content || selectedTpl.text || ''

        if (content) {
            const selectedEquipmentNames = selectedEquipment.value
                .map(id => getNameFromDict(equipmentList.value, id))
                .filter(Boolean)
                .join(', ')

            const replacements = {
                '{Marka}': getMakeName(formData.value.makeID),
                '{Model}': getModelName(formData.value.modelID),
                '{Generacja}': getNameFromDict(generationsList.value, formData.value.generationID),
                '{Rok}': formData.value.productionYear ? String(formData.value.productionYear) : '',
                '{Przebieg}': formData.value.mileage ? `${formData.value.mileage} km` : '',
                '{Pojemnosc}': formData.value.engineCCM ? `${formData.value.engineCCM} cm³` : '',
                '{Moc}': formData.value.powerKM ? `${formData.value.powerKM} KM` : '',
                '{Paliwo}': getNameFromDict(dicts.fuelTypes, formData.value.fuelTypeID),
                '{Skrzynia}': getNameFromDict(dicts.gearboxes, formData.value.gearboxID),
                '{Nadwozie}': getNameFromDict(dicts.bodyTypes, formData.value.bodyTypeID),
                '{Kolor}': getNameFromDict(dicts.colours, formData.value.colourID),
                '{Naped}': getNameFromDict(dicts.driveTypes, formData.value.driveTypeID),
                '{Kraj}': getNameFromDict(dicts.countries, formData.value.countryID),
                '{Cena}': formData.value.price ? `${formData.value.price} PLN` : '',
                '{VIN}': formData.value.VIN || '',
                '{Rejestracja}': formData.value.registerNumber || '',
                '{PierwszaRejestracja}': formData.value.firstRegistrationDate || '',
                '{Wyposazenie}': selectedEquipmentNames
            }

            Object.keys(replacements).forEach(tag => {
                const escapedTag = tag.replace(/[{}]/g, '\\$&')
                const regex = new RegExp(escapedTag, 'gi')
                content = content.replace(regex, replacements[tag])
            })

            const textarea = textareaRef.value
            const currentValue = formData.value.offerDesc || ''

            if (textarea) {
                const start = textarea.selectionStart ?? currentValue.length
                const end = textarea.selectionEnd ?? currentValue.length
                const scrollTop = textarea.scrollTop

                formData.value.offerDesc = currentValue.substring(0, start) + content + currentValue.substring(end)

                nextTick(() => {
                    textarea.scrollTop = scrollTop
                    textarea.focus({ preventScroll: true })
                    const newCursorPos = start + content.length
                    textarea.setSelectionRange(newCursorPos, newCursorPos)
                })
            } else {
                formData.value.offerDesc = currentValue + (currentValue ? '\n' : '') + content
            }

        } else {
            webAlert('Wybrany szablon jest pusty.')
        }
    }

    event.target.value = ''
}

const loadEquipment = async () => {
    loadingEquipment.value = true
    try {
        equipmentList.value = await fetchDict('get-equipment')
    } catch {
        equipmentList.value = []
    } finally {
        loadingEquipment.value = false
    }
}

const loadGenerations = async (modelID) => {
    if (!modelID) {
        generationsList.value = []
        return
    }
    loadingGenerations.value = true
    try {
        generationsList.value = await fetchDict('get-generations', { modelID })
    } catch {
        generationsList.value = []
    } finally {
        loadingGenerations.value = false
    }
}

const onPowerKMChange = () => {
    if (!formData.value.powerKM) {
        formData.value.powerKW = ''
        return
    }
    formData.value.powerKW = Math.round(Number(formData.value.powerKM) * 0.735499)
}

const onPowerKWChange = () => {
    if (!formData.value.powerKW) {
        formData.value.powerKM = ''
        return
    }
    formData.value.powerKM = Math.round(Number(formData.value.powerKW) * 1.35962)
}

const resetForm = () => {
    formData.value = {
        ID: '', dealerID: null, makeID: null, modelID: null, generationID: null, statusID: null,
        fuelTypeID: null, gearboxID: null, bodyTypeID: null, colourID: null, driveTypeID: null, countryID: null,
        VIN: '', registerNumber: '', price: '', priceNetto: false, negotiable: false, vatMargin: false, vatInvoice: false,
        keyCount: '', keyNumber: '', deliveryPossible: false, warranty3m: false, warranty12m: false, warranty24m: false,
        ocInsurance: false, firstRegistrationDate: '', engineCCM: '', powerKM: '', powerKW: '', type: null,
        mileage: '', productionYear: new Date().getFullYear(), doorCount: 5, seatsCount: 5,
        damaged: 'no', imported: 'no', accidentFree: 'no', offerDesc: '', active: false
    }
    photosList.value = []
    selectedEquipment.value = []
    generationsList.value = []
    dicts.models = []
    if (fileInput.value) fileInput.value.value = ''
}

const openAddModal = () => {
    formTitle.value = 'Dodaj nowy samochód'
    resetForm()
    modalInstance.show()
}

const openEditModal = async (id) => {
    savingTXT.value = 'Pobieranie szczegółów ...'
    saving.value = true
    try {
        const response = await apiClient.post({ action: 'get-car-details', ID: id })

        const item = response.data?.data?.[0] || response.data?.data || response.data
        formTitle.value = `Edytuj: ${item.make || ''} ${item.model || ''} (ID: ${item.ID})`

        formData.value = {
            ...item,
            statusID: item.statusID || null,
            countryID: item.countryID || null,
            registerNumber: item.registerNumber || item.register_number || item.registerPlates || '',
            priceNetto: item.priceNetto === 'yes' || item.priceNetto === true,
            negotiable: item.negotiable === 'yes' || item.negotiable === true,
            vatMargin: item.vatMargin === 'yes' || item.vatMargin === true,
            vatInvoice: item.vatInvoice === 'yes' || item.vatInvoice === true,
            keyCount: item.keyCount || '',
            keyNumber: item.keyNumber || '',
            type: item.type || '',
            deliveryPossible: item.deliveryPossible === 'yes' || item.deliveryPossible === true,
            warranty3m: item.warranty3m === 'yes' || item.warranty3m === true,
            warranty12m: item.warranty12m === 'yes' || item.warranty12m === true,
            warranty24m: item.warranty24m === 'yes' || item.warranty24m === true,
            ocInsurance: item.ocInsurance === 'yes' || item.ocInsurance === true,
            damaged: item.damaged || 'no',
            imported: item.imported || 'no',
            accidentFree: item.accidentFree || 'no',
            offerDesc: item.offerDesc || '',
            active: item.active === 'yes'
        }

        if (item.makeID) {
            dicts.models = await fetchDict('get-models', { makeID: item.makeID })
        }

        localStorage.setItem('max_photos', response.data.ctd.imagesToAdvert)
        maxPhotosAllowed.value = response.data.ctd.imagesToAdvert

        if (item.modelID) await loadGenerations(item.modelID)

        selectedEquipment.value = Array.isArray(item.equipment)
            ? item.equipment.map(eq => Number(typeof eq === 'object' ? eq.ID || eq.id : eq))
            : []
        if (Array.isArray(item.photos)) {
            photosList.value = item.photos.map(p => ({
                file: null,
                preview: p.preview,
                isExisting: true,
                photoID: p.photoID,
                main: p.main === 'yes'
            }))
        } else {
            photosList.value = []
        }

        modalInstance.show()
    } catch {
        webAlert('Błąd podczas pobierania danych pojazdu.')
    } finally {
        saving.value = false
    }
}

const triggerFileInput = () => {
    if (photosList.value.length >= maxPhotosAllowed.value) {
        webAlert(`Osiągnięto maksymalny limit ${maxPhotosAllowed.value} zdjęć.`)
        return
    }
    fileInput.value?.click()
}

const processFiles = (files) => {
    const availableSlots = maxPhotosAllowed.value - photosList.value.length

    if (availableSlots <= 0) {
        webAlert(`Osiągnięto limit ${maxPhotosAllowed.value} zdjęć.`)
        return
    }

    const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'))

    if (validFiles.length > availableSlots) {
        webAlert(`Wybrano więcej plików niż przewiduje Twój limit. Dodano pierwsze ${availableSlots} szt.`)
    }

    const filesToProcess = validFiles.slice(0, availableSlots)

    filesToProcess.forEach(file => {
        photosList.value.push({
            file: file,
            preview: URL.createObjectURL(file),
            isExisting: false,
            photoID: null,
            main: photosList.value.length === 0
        })
    })
}

const handlePhotosSelect = (e) => {
    if (e.target.files) {
        processFiles(e.target.files)
        e.target.value = ''
    }
}

const handleDrop = (e) => {
    isDragging.value = false
    if (e.dataTransfer?.files) processFiles(e.dataTransfer.files)
}

const removePhoto = (index) => {
    const wasMain = photosList.value[index].main
    photosList.value.splice(index, 1)
    if (wasMain && photosList.value.length > 0) {
        photosList.value[0].main = true
    }
}

const setMainPhoto = (index) => {
    photosList.value.forEach((p, i) => { p.main = (i === index) })
}

const movePhoto = (index, direction) => {
    const newIndex = index + direction
    if (newIndex < 0 || newIndex >= photosList.value.length) return
    const temp = photosList.value[index]
    photosList.value[index] = photosList.value[newIndex]
    photosList.value[newIndex] = temp
}

const handleSubmit = async () => {
    savingTXT.value = 'Zapisywanie pojazdu oraz zdjęć...'
    saving.value = true

    try {
        const payload = new FormData()
        payload.append('action', 'save-car')
        payload.append('id', formData.value.ID || '')
        payload.append('dealerID', formData.value.dealerID || '')
        payload.append('makeID', formData.value.makeID || '')
        payload.append('modelID', formData.value.modelID || '')
        payload.append('generationID', formData.value.generationID || '')
        payload.append('statusID', formData.value.statusID || '')
        payload.append('fuelTypeID', formData.value.fuelTypeID || '')
        payload.append('gearboxID', formData.value.gearboxID || '')
        payload.append('bodyTypeID', formData.value.bodyTypeID || '')
        payload.append('colourID', formData.value.colourID || '')
        payload.append('driveTypeID', formData.value.driveTypeID || '')
        payload.append('countryID', formData.value.countryID || '')
        payload.append('VIN', formData.value.VIN || '')
        payload.append('registerNumber', formData.value.registerNumber || '')
        payload.append('price', formData.value.price || 0)
        payload.append('priceNetto', formData.value.priceNetto ? 'yes' : 'no')
        payload.append('negotiable', formData.value.negotiable ? 'yes' : 'no')
        payload.append('vatMargin', formData.value.vatMargin ? 'yes' : 'no')
        payload.append('vatInvoice', formData.value.vatInvoice ? 'yes' : 'no')
        payload.append('keyCount', formData.value.keyCount || 0)
        payload.append('keyNumber', formData.value.keyNumber || '')
        payload.append('deliveryPossible', formData.value.deliveryPossible ? 'yes' : 'no')
        payload.append('warranty3m', formData.value.warranty3m ? 'yes' : 'no')
        payload.append('warranty12m', formData.value.warranty12m ? 'yes' : 'no')
        payload.append('warranty24m', formData.value.warranty24m ? 'yes' : 'no')
        payload.append('ocInsurance', formData.value.ocInsurance ? 'yes' : 'no')
        payload.append('firstRegistrationDate', formData.value.firstRegistrationDate || '')
        payload.append('type', formData.value.type || '')
        payload.append('engineCCM', formData.value.engineCCM || 0)
        payload.append('powerKM', formData.value.powerKM || 0)
        payload.append('powerKW', formData.value.powerKW || 0)
        payload.append('mileage', formData.value.mileage || 0)
        payload.append('productionYear', formData.value.productionYear || 0)
        payload.append('doorCount', formData.value.doorCount || 0)
        payload.append('seatsCount', formData.value.seatsCount || 0)
        payload.append('damaged', formData.value.damaged || 'no')
        payload.append('imported', formData.value.imported || 'no')
        payload.append('accidentFree', formData.value.accidentFree || 'no')
        payload.append('offerDesc', formData.value.offerDesc || '')
        payload.append('active', formData.value.active ? 'yes' : 'no')

        payload.append('equipment', JSON.stringify(selectedEquipment.value))

        const photosMeta = photosList.value.map((p, idx) => ({
            position: idx + 1,
            main: p.main ? 'yes' : 'no',
            isExisting: p.isExisting,
            photoID: p.photoID
        }))
        payload.append('photosMeta', JSON.stringify(photosMeta))

        photosList.value.forEach((p) => {
            if (!p.isExisting && p.file) {
                payload.append('photos[]', p.file)
            }
        })

        const response = await apiClient.post(
            payload
        )

        saving.value = false

        if (response.data?.status == 'success') {
            modalInstance.hide()
            await loadData()
        }
        
        await webAlert(response.data)
    } catch {
        webAlert('Błąd podczas zapisu formularza.')
    } finally {
        saving.value = false
    }
}

const deleteItem = async (id) => {
    const confirmed = await showConfirm('Czy na pewno chcesz usunąć to ogłoszenie i przypisane zdjęcia?', {
        title: 'Usuwanie samochodu',
        confirmText: 'Usuń',
        cancelText: 'Anuluj',
        confirmClass: 'btn-danger',
        icon: 'bi-trash text-danger'
    })

    if (!confirmed) return

    saving.value = true
    savingTXT.value = "Kasowanie..."
    try {
        const response = await apiClient.post({ action: 'delete-car', id })
        await loadData()
        webAlert(response.data)
    } catch {
        webAlert('Błąd podczas usuwania pozycji.')
    } finally {
        saving.value = false
    }
}

onMounted(() => {
    modalInstance = new Modal(modalRef.value)
    pdfModalInstance = new Modal(pdfModalRef.value)
    loadDictionaries()
    loadEquipment()
    loadData()
})
</script>

<style scoped>
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    max-width: calc(100vw - 2rem) !important;
    -webkit-overflow-scrolling: touch;
}

:deep(.vue3-easy-data-table) {
    --easy-table-border: 1px solid #dee2e6;
    --easy-table-row-border: 1px solid #dee2e6;
    --easy-table-header-font-size: 0.85rem;
    --easy-table-header-height: 45px;
    --easy-table-body-row-height: 50px;

    width: 100% !important;
    max-width: 100% !important;
}

:deep(.vue3-easy-data-table__main) {
    width: 100% !important;
    overflow-x: auto !important;
}

.btn-xs {
    padding: 0.15rem 0.4rem;
    font-size: 0.75rem;
}

.custom-scroll-body {
    overflow-y: auto;
    max-height: calc(85vh - 130px);
}

.drop-zone {
    border: 2px dashed var(--drop-zone-border);
    background-color: var(--drop-zone-bg);
    color: var(--drop-zone-text);
    transition: all 0.2s ease;
}

.drop-zone:hover,
.drop-zone-active {
    border-color: var(--drop-zone-hover-border);
    background-color: var(--drop-zone-hover-bg);
}

.cursor-pointer {
    cursor: pointer;
}

.cursor-not-allowed {
    cursor: not-allowed;
}

.extra-small {
    font-size: 0.75rem;
}
</style>